import { RegisterStateType } from 'src/core/models'

export const getUserDataTransformed = (user: RegisterStateType, language: string) => {
  return {
    email: user.credentials.email,
    password: user.credentials.password,
    password_confirmation: user.credentials.confirmPassword,
    first_name: user.personalDetails.firstName,
    last_name: user.personalDetails.lastName,
    country: user.personalDetails.country,
    phone: user.personalDetails.phone,
    invitationCode: '',
    company_name: user.rol === 'INDIVIDUAL' ? '-' : user.personalDetails.companyName,
    company_size: user.personalDetails.companySize,
    Company_website: '-',
    is_business: user.rol === 'COMPANY',
    is_widget: user.rols.isWidget,
    groups: user.rols.isProducer ? ['offsetters', 'producers'] : ['offsetters'],
    language: language,
    company_country: user.personalDetails.country,
    mint_nft: false,
    consent_details: {
      commercial_communications: user.rols.hasCommercialCommunications
    }
  }
}
